export default __webpack_public_path__ + "static/media/health care medical.0ca20157.png";